import { getApiBase } from './session';
import { httpFetch } from './http';
import { getStoredAuthToken } from './userApi';
export async function fetchCategories(userId, language = 'zh-CN', select = false) {
    const base = getApiBase();
    const url = `${base}/api/categories?user_id=${encodeURIComponent(userId)}&language=${encodeURIComponent(language)}${select ? '&select=true' : ''}`;
    const res = await httpFetch(url, { timeoutMs: 10000 });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return data.categories || [];
}
export async function fetchAdventures(userId, categoryId, language = 'zh-CN') {
    const base = getApiBase();
    const qs = new URLSearchParams({ user_id: userId, language });
    if (categoryId)
        qs.set('category_id', categoryId);
    const token = getStoredAuthToken();
    const res = await httpFetch(`${base}/api/adventures?${qs.toString()}`, {
        timeoutMs: 10000,
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return data.adventures || [];
}
export async function deleteSessionRest(userId, sessionId, adventureId) {
    const base = getApiBase();
    const url = `${base}/api/delete_session`;
    const res = await httpFetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, session_id: sessionId, adventure_id: adventureId })
    });
    if (!res.ok) {
        return { success: false, error: `HTTP ${res.status}` };
    }
    try {
        const data = await res.json();
        if (data && data.success !== false) {
            return { success: true };
        }
        return { success: false, error: data?.error || 'unknown_error' };
    }
    catch {
        return { success: true };
    }
}
export async function fetchModels(userId, language = 'zh-CN') {
    const base = getApiBase();
    const qs = new URLSearchParams({ user_id: userId, language });
    const res = await httpFetch(`${base}/api/models?${qs.toString()}`, { timeoutMs: 10000 });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    const list = Array.isArray(data) ? data : (data.models || []);
    const out = [];
    const seen = new Set();
    for (const it of list || []) {
        let name = '';
        let model = '';
        if (typeof it === 'string') {
            // If server returns a plain string, treat it as the model id, and use it as both name/model
            model = String(it).trim();
            name = model;
        }
        else if (it && typeof it === 'object') {
            model = String(it.model || it.code || it.model_code || '').trim();
            name = String(it.name || it.model_name || model).trim();
        }
        if (!model)
            continue;
        const key = model.toLowerCase();
        if (seen.has(key))
            continue; // keep first occurrence only
        seen.add(key);
        out.push({ name, model });
    }
    return out;
}
// Create a temporary share token for inviting others to start a session from a link.
// Server is expected to validate/expire this token when used.
export async function createShareToken(userId, scriptId) {
    const base = getApiBase();
    const res = await httpFetch(`${base}/api/create_share_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, script_id: scriptId }),
        timeoutMs: 10000,
    });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    const token = (data && (data.token || data.share_token)) || '';
    if (typeof token !== 'string' || !token)
        throw new Error('No token returned');
    return token;
}
